// export const REFERRAL_BASE_URL = "http://13.209.13.111:4000";
// export const API_BASE_URL = "http://localhost:3000";

export const REFERRAL_BASE_URL = "https://airdrop.bingold.to";
export const API_BASE_URL = "https://node-airdrop.bingold.to";

export const rpcUrl = "https://bsc.blockrazor.xyz";

export const LOCALSTORAGES = {
  TOKEN: "udx_k_01_tkn",
  USER: "user",
};

export const mainContract = "0xf52D3a84DDb46F1C1a8B9e338cB70E895762F9A9";
export const usdtContracts = "0x11526f93BE5f26220E9c7EACB587EdAEBaa9f627";

const DASHBOARD_BASE = "/dashboard";

export const DASHBOARD_ROUTES = {
  DASHBOARD: `${DASHBOARD_BASE}`,
  CAMPAIGNS: `${DASHBOARD_BASE}/campaigns`,
  CAMPAIGNS_NEW: `${DASHBOARD_BASE}/campaigns/new`,
  CAMPAIGNS_DETAIL: (id: string) => `${DASHBOARD_BASE}/campaigns/${id}`,
  CAMPAIGNS_EDIT: (id: string) => `${DASHBOARD_BASE}/campaigns/${id}/edit`,
  USERS: `${DASHBOARD_BASE}/users`,
  KOL: `${DASHBOARD_BASE}/kolMangement`,
  TRANSACTIONS: `${DASHBOARD_BASE}/transactions`,
  WALLETS: `${DASHBOARD_BASE}/wallets`,
  FINANCIAL: `${DASHBOARD_BASE}/financial`,
  REFERRALS_CODE: `${DASHBOARD_BASE}/referrals-code`,
  REFERRALS_CODE_USERS: `${DASHBOARD_BASE}/referrals-code-users`,
  SETTINGS: `${DASHBOARD_BASE}/settings`,
};

export const AUTH_API_ENDPOINT = {
  SIGNIN: "/api/v1/admin/login",
  VERIFY_OTP: "/api/v1/admin/verifyOTP",
  RESEND_OTP: "/api/v1/admin/resendOtp",
  FORGOT_PASSWORD: "/api/v1/admin/forgotPassword",
  RESET_PASSWORD: "/api/v1/admin/resetPassword",
  CHANGE_PASSWORD: "/api/v1/admin/changePassword",
  GET_PROFILE: "/api/v1/admin/getProfile",
  UPDATE_PROFILE: "/api/v1/admin/editProfile",
  GET_SUB_ADMIN: "/api/v1/admin/listSubAdmin",
  CREATE_SUB_ADMIN: "/api/v1/admin/addSubAdmin",
  DELETE_SUB_ADMIN: "/api/v1/admin/deleteSubAdmin",
  CHANGE_SUB_ADMIN_STATUS: "/api/v1/admin/blockUnblockSubAdmin",
  GET_NOTIFICATIONS_ACTIVITY: "/api/v1/notification/listActivity",
  ADD_REFERRAL: "/api/v1/admin/addCode",
  ADD_REFERRAL_USER: "/api/v1/admin/addCodeUser",
  GET_REFFERAL: "/api/v1/admin/userReferralList",
  GET_REFFERAL_USER: "/api/v1/admin/listCodesUser",
  GET_REFFERAL_CODE: "/api/v1/admin/listCodes",
  DELETE_REFFERAL: "/api/v1/admin/deleteCode",
  DELETE_REFFERAL_USER: "/api/v1/admin/deleteCodeUser",
  CHANGE_STATUS_REFFERAL: "/api/v1/admin/blockUnblockCode",
  CHANGE_STATUS_REFFERAL_USER: "/api/v1/admin/blockUnblockCodeUser",
};

export const CAMPAIGNS_API_ENDPOINT = {
  GET_CAMPAIGNS_ANALYTICS: "/api/v1/campaign/campaignDashBoard",
  GET_CAMPAIGNS: "/api/v1/campaign/listCampaign",
  GET_ASSIGNED_CAMPAIGNS: "/api/v1/campaign/listCampaignAssigned",

  GET_CAMPAIGN_BY_ID: "/api/v1/campaign/viewCampaign",
  CREATE_CAMPAIGN: "/api/v1/campaign/addCampaign",
  UPDATE_CAMPAIGN: "/api/v1/campaign/editCampaign",
  CHANGE_CAMPAIGN_STATUS: "/api/v1/campaign/changeStatusCampaign",
  VIEW_SOCIAL_CREDNETIALS: "/api/v1/campaign/viewSocialCredentials",
  GET_TOTAL_TASK_AMOUNT: "/api/v1/campaign/totalTaskAmount",
  getBinGoldPrice: "/api/v1/campaign/getBinGoldPrice",
  GET_CODES: "/api/v1/campaign/listCodes",
  GENRATE_CODES: "/api/v1/campaign/generateCode",
};

export const TASKS_API_ENDPOINT = {
  GET_TASKS_ANALYTICS: "/api/v1/campaign/taskDashBoard",
  GET_TASKS: "/api/v1/campaign/listTasks",
  CREATE_TASK: "/api/v1/campaign/addTask",
  UPDATE_TASK: "/api/v1/campaign/editTask",
  CHANGE_TASK_STATUS: "/api/v1/campaign/changeStatusTasks",
};

export const USERS_API_ENDPOINT = {
  GET_USERS_ANALYTICS: "/api/v1/admin/DashBoard",
  GET_USERS: "/api/v1/admin/userList",

  GET_GRAPH_DATA: "/api/v1/admin/graphForUser",
  VIEW_USER: "/api/v1/admin/viewUser",
  CHANGE_USER_STATUS: "/api/v1/admin/activeBlockUser",
  DELETE_USER: "/api/v1/admin/deleteUser",
  DISTRIBUTE_REWARDS: "/api/v1/admin/distributeRewards",
  ADD_KOL: "/api/v1/admin/addKol",
};

export const TRANSACTIONS_API_ENDPOINT = {
  GET_TRANSACTIONS: "/api/v1/transaction/transactionHistory",
};

export const WALLETS_API_ENDPOINT = {
  GET_WALLETS: "/api/v1/admin/viewWalletAddress",
  UPDATE_WALLET: "/api/v1/admin/updateWalletAddress",
};
